import { Entity } from './entity';
import { environment } from '../../environments/environment';

export class SearchHistory extends Entity {

    text: string;
    date: Date;

    constructor(text) {
        super();
        this.text = text;
        this.date = new Date();
    }

    getEndpointName(): string {
        return environment.endpointUrls.pageSearch;
    }
}
